function storeItemListColumn(data: { showActions?: boolean } = {}) {
  const { showActions = true } = data;

  const cols = [
    {
      id: "_id",
      label: `Store ID`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "type",
      label: `Type`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "purchaseMethod",
      label: `Purchase Mthd.`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "pbfCoin",
      label: `PBF Coin`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "buyPrice",
      label: `Buy Price`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "bonus",
      label: `Bonus`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isDisabledText",
      label: "Is Disabled?",
      type: "boolean",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    // {
    //   id: "bonusTxt",
    //   label: `Bonus Txt`,
    //   type: "string",
    //   isSortable: true,
    //   alignHead: "center",
    //   alignBody: "center",
    // },
    // {
    //   id: "buyCoins",
    //   label: `Buy Coins`,
    //   type: "string",
    //   isSortable: true,
    //   alignHead: "center",
    //   alignBody: "center",
    // }
  ];

  // if (showPreview) {
  //   cols.push({ id: "thumbnail", label: "Preview" });
  // }

  if (showActions) {
    cols.push({ id: "actions", label: "Actions" } as any);
  }

  return cols;
}

export const storeBannersTableCols = (params = {}) => {
  return [
    {
      id: "_id",
      label: `SB. ID`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "order",
      label: `Store Order`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "title",
      label: `Title`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "body",
      label: `Body`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isActiveText",
      label: `Is Active?`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "textColor",
      label: `Text Color`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "thumbnail", label: "Preview" },
    {
      id: "actions",
      label: "Actions",
    },
  ];
};

export { storeItemListColumn };
